export default __webpack_public_path__ + "static/media/sucess.62ef168f.svg";